<div class="card p-3">
  <div class="row align-items-end mb-2">
    <!-- Search ID -->
    <div class="col-lg-6 col-md-12 mb-2">
      <mat-form-field appearance="outline" class="w-100 mb-0">
        <mat-label>Search ID</mat-label>
        <input matInput type="text" placeholder="Search ID..." (keyup)="updateFilter($event)" />
      </mat-form-field>
    </div>

    <!-- Date Filter -->
    <div class="col-lg-6 col-md-12 mb-2">
      <mat-form-field appearance="outline" class="w-100 mb-0">
        <mat-label>Search By Date</mat-label>

        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input matStartDate readonly formControlName="start" placeholder="Start date" />
          <input matEndDate readonly formControlName="end" placeholder="End date" />


        </mat-date-range-input>

        <div matSuffix style="display: flex; align-items: center; gap: 1px;">
          <button mat-icon-button *ngIf="range.value?.start || range.value?.end" (click)="clearDateRange()"
            type="button">
            <i class="bi bi-x-circle" style="font-size: 15px; color: #707070;"></i>
          </button>
          <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
        </div>



        <mat-date-range-picker #picker (closed)="showDate()"></mat-date-range-picker>
      </mat-form-field>
    </div>


  </div>


  <!-- Bottom Row: Filter Buttons + Export -->
  <div class="row align-items-center">
    <!-- Filter Buttons Left -->
    <div class="col-lg-9 col-md-12 d-flex gap-2 flex-wrap mb-2">
      <button class="btn btn-success btn-sm" (click)="getAstroCreditedWalletHistory()">Recharged Transc.</button>
      <button class="btn btn-primary btn-sm" (click)="getAstroDebitedWalletHistory()">Deducted Transc.</button>
      <button class="btn btn-info btn-sm" (click)="getAstroWalletTransactionsByAdmin()">Admin Transc.</button>
    </div>

    <!-- Export Button Right -->
    <div class="col-lg-3 col-md-6 text-right mb-2">
      <button class="btn btn-success btn-sm w-100" (click)="generateExcel()">Export</button>
    </div>
  </div>
</div>


<br>
<ngx-datatable class="material" [rows]="data" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
  [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10" [sorts]="[{dir: 'desc'}]"
  style="position: relative !important;">
  <ngx-datatable-column [flexGrow]="1" name="Wallet Id" prop="adminwalletId">
    <ng-template let-row="row" ngx-datatable-cell-template>
      #{{row.adminwalletId}}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column [flexGrow]="1" name="Type">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span *ngIf="row.txn_type == 1" class="rounded-1 p-1 text-bg-success">Recharged</span>
      <span *ngIf="row.txn_type == 2" class="rounded-1 p-1 text-bg-primary">Deducted</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column [flexGrow]="1" name="Amount" prop="amount">
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{row.currencySymbol}}{{row.amount | number: '.2-2'}} ({{row.currencyCode}})
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column [flexGrow]="1" name="Balance" prop="balance">
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{row.currencySymbol}}<span *ngIf="!row.isForeignOrder">{{row.balance | number: '.2-2'}}</span>
      <span *ngIf="row.isForeignOrder">{{row.foreignBalance | number: '.2-2'}}</span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column [flexGrow]="3" name="Wallet Remarks" prop="wallet_comments">
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{row.wallet_comments}}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column [flexGrow]="1" name="Txn. ID" prop="txnId">
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{row.txnId}}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column [flexGrow]="2" name="Date" prop="created_at">
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{row.created_at | date:'medium'}}
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>